export function isNotEmptyString(value) {
    return typeof value === 'string' && value.trim().length > 0;
}
export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
export function validate(condition, message) {
    if (!condition) {
        throw new Error(message);
    }
}
//# sourceMappingURL=validationUtilities.js.map